var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.04023 2.2403C4.22716 0.0533637 7.77289 0.0533634 9.95982 2.2403C12.1468 4.42724 12.1468 7.97296 9.95982 10.1599L6.00002 14.1197L2.04023 10.1599C-0.14671 7.97296 -0.14671 4.42724 2.04023 2.2403ZM6.00002 7.8001C6.88368 7.8001 7.60002 7.08375 7.60002 6.2001C7.60002 5.31644 6.88368 4.6001 6.00002 4.6001C5.11637 4.6001 4.40002 5.31644 4.40002 6.2001C4.40002 7.08375 5.11637 7.8001 6.00002 7.8001Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMarker);
export default __webpack_public_path__ + "static/media/location-marker.065e2d4b57eb89ec0e326b8f36c86dc7.svg";
export { ForwardRef as ReactComponent };